import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance27cl4xxdoduaj as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import { Companion_getInstance3bjjjd8igr9ok as Companion_getInstance } from './coreInterfaces.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_AppJob() {
  _init_properties_AppScope_kt__e9fb1p();
  return AppJob;
}
var AppJob;
function get_AppScope() {
  _init_properties_AppScope_kt__e9fb1p();
  return AppScope;
}
var AppScope;
var AppScope$$inlined$CoroutineExceptionHandler$1Class;
function AppScope$$inlined$CoroutineExceptionHandler$1() {
  if (AppScope$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor() {
        super(Key_instance);
      }
      handleException_e679jj_k$(context, exception) {
        Companion_getInstance().reportException_1(exception);
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Element()]);
    AppScope$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return AppScope$$inlined$CoroutineExceptionHandler$1Class;
}
var properties_initialized_AppScope_kt_9z3ewb;
function _init_properties_AppScope_kt__e9fb1p() {
  if (!properties_initialized_AppScope_kt_9z3ewb) {
    properties_initialized_AppScope_kt_9z3ewb = true;
    AppJob = SupervisorJob();
    var tmp = get_AppJob();
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new (AppScope$$inlined$CoroutineExceptionHandler$1())();
    AppScope = CoroutineScope(tmp.plus_s13ygv_k$(tmp$ret$0).plus_s13ygv_k$(Dispatchers_getInstance().get_Main_wo5vz6_k$().get_immediate_r3y8eg_k$()));
  }
}
//region block: exports
export {
  get_AppScope as get_AppScopes4bqeg21n0qw,
};
//endregion

//# sourceMappingURL=AppScope.mjs.map
